import FadeInSection from "../../../animations/FadeInSection";
import PrescriptionFilled from "../../../appointments-details-components/PrescriptionFilled";

const PrescriptionDetails = () => {
  return (
    <div className="px-6 py-4 md:px-20">
      <FadeInSection>
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-semibold">Prescription Detail</h1>
        </div>

        <div className="w-full rounded-lg border border-gray-200 overflow-hidden p-6">
          <PrescriptionFilled />
        </div>
      </FadeInSection>
    </div>
  );
};

export default PrescriptionDetails;
